import { lazyLoad } from 'utils/loadable';

export const Admins = lazyLoad(() => import('./index'));
